module.exports = __webpack_public_path__ + "static/img/2.e29aa0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/2.png
// module id = 246
// module chunks = 0